export const FETCH_USER_REPORT_SUCCESS = 'FETCH_USER_REPORT_SUCCESS';
export const FETCH_USER_REPORT_FAILURE = 'FETCH_USER_REPORT_FAILURE';